<template>
    <v-footer id="footer1" class="mb-5" fixed dark>
        <v-card class="flex" flat>
            <v-card-title>
                <a href="https://datachester.com" class="hidden-xs-only">
                    <v-avatar size="50px">
                        <img class="img-circle" src="/static/person/eddy.jpg">
                    </v-avatar>
                </a>
                <p class="text--accent-2, text-xs-right hidden-xs-only"><strong>Production of Data Chester Inc.</strong></p>
            </v-card-title>

            <v-card-actions class="wrap justify-center xs12" >
                <p class="hidden-sm-and-up full-width xs12 align-center">&copy2014 - 2018 <strong>Prudent Accounting & Insurance Brokerage</strong></p>

                <div></div>
                <p class="hidden-xs-only">&copy2014 - 2018<strong>Prudent Accounting Services LLC. & Prudent Insurance Brokerage INC.</strong></p>

            </v-card-actions>
        </v-card>
    </v-footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style>
   #footer1{
       display: flex;
   }
</style>


// WEBPACK FOOTER //
// src/components/layout/Footer.vue